// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"e4a6d6d5","804":"b4ae900b","827":"762ed907"}[chunkId] + ".chunk.js";
};